/**
 * UI Constants
 * Shared constants for UI components across the application
 */

// Default avatar image used throughout the application
export const DEFAULT_AVATAR_URL = "/avatar-1.webp" 